import { StatsigClient } from '@statsig/js-client';
import { getLanguageFromPath, getBasePathWithoutLanguage } from 'src/utils/i18n-config';

let statsigClientInstance: StatsigClient | null = null;
let isClientInitialized = false;

export const setStatsigClient = (client: StatsigClient): void => {
  statsigClientInstance = client;

  // Track when initialization completes
  client.initializeAsync().then(() => {
    isClientInitialized = true;
  });
};

export const getStatsigClient = (): StatsigClient => {
  if (!statsigClientInstance) {
    throw new Error('Statsig client not initialized');
  }
  return statsigClientInstance;
};

export const isStatsigInitialized = (): boolean => {
  return isClientInitialized;
};

const getPageMetadata = (): Record<string, string> => {
  if (typeof window === 'undefined' || !window.location) {
    return {};
  }

  const pathname = window.location.pathname;
  return {
    current_page_path: getBasePathWithoutLanguage(pathname),
    current_selected_language: getLanguageFromPath(pathname),
  };
};

export const logStatsigEvent = (
  eventName: string,
  value?: string | number,
  metadata?: Record<string, any>
): void => {
  if (!statsigClientInstance) {
    console.warn('Statsig client not initialized, skipping event:', eventName);
    return;
  }

  const pageMetadata = getPageMetadata();
  const enrichedMetadata = { ...metadata, ...pageMetadata };

  statsigClientInstance.logEvent(eventName, value, enrichedMetadata);

  // Bridge to GA4: push every Statsig event to the GTM dataLayer
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...(value !== undefined && { value }),
      ...enrichedMetadata,
    });
  }
};

// Test helper - only use in tests to inject mock client
export const __setStatsigClientForTesting__ = (client: StatsigClient | null): void => {
  statsigClientInstance = client;
  if (client) {
    isClientInitialized = true;
  } else {
    isClientInitialized = false;
  }
};
